import React, { useEffect, useState } from 'react';
import Layouts from '../../../components/Layouts';
import {
  Button,
  Form,
  Modal,
  Select,
  Space,
  Table,
  Tabs,
  Typography,
  Upload,
} from 'antd';
import { getDirectusClient } from '../../../lib/directus';
import {
  MinusCircleOutlined,
  PlusOutlined,
  EyeOutlined,
  DeleteOutlined,
  UploadOutlined,
} from '@ant-design/icons';

import {
  createItem,
  readItems,
  readUsers,
  updateItem,
  updateItems,
  updateUser,
} from '@directus/sdk';
import { useSelector } from 'react-redux'; // Add this import
import Caja from '../../loans_routes/components/Caja';
import Serial from '../../loans_routes/components/Serial';
import Grupo from '../../loans_routes/components/Grupo';
import AddNoSerial from '../../loans_routes/components/AddNoSerial';
import { formatPrice, truncateSerial } from '../../../lib/utils';
import Constants from '../../../lib/Constants';
const { Title } = Typography;
const { Option } = Select;
const arraytotalproductos = [];
let deletecambio = false;

function TroopLoansCreate(props) {
  const [supervisores, setSupervisores] = useState([]);
  const [supervisorSelect, setSupervisorSelect] = useState({});
  const signoMoneda = useSelector(state => state.signoMoneda.signo_moneda);
  const omitir1 = useSelector(state => state.omitir1.omitir1); // Agregar selector de omitir1
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);

  const [serialeslist, setSerialeslist] = useState([]);
  const [modalseriales, setModalseriales] = useState(false);
  const [productosagregados, setProductosagregados] = useState([]);
  const [productosagregadosver, setProductosagregadosver] = useState([]);
  const [fileList, setFileList] = useState([]);

  const [total, setTotal] = useState(0); // First, convert total to a state variable

  const [form] = Form.useForm();

  const userBodega = useSelector(state => state.userdata.bodega?.id); // Add userBodega selector
  const user = useSelector(state => state.userdata?.id);
  const [supervisorSearch, setSupervisorSearch] = useState('');

  const items = [
    {
      key: '1',
      label: `Por caja`,
      children: (
        <Caja
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: '2',
      label: `Por serial`,
      children: (
        <Serial
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: '3',
      label: `Por caja y grupo`,
      children: (
        <Grupo
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: '4',
      label: `No Serializado`,
      children: (
        <AddNoSerial
          onAddItem={item => {
            setProductosagregados(prev => [
              ...prev,
              { ...item, isNonSerialized: true },
            ]);
          }}
          productosagregados={productosagregados || []}
        />
      ),
    },
  ];

  const getSupervisores = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          fields: [
            'id',
            'first_name',
            'last_name',
            'documento',
            'tope_de_prestamo',
            'prestamo_usado',
          ],
          filter: {
            role: {
              name: { _contains: 'supervisor_tropas' },
            },
            bodega: { id: { _eq: userBodega } },
          },
          sort: ['first_name'],
        })
      );
      setSupervisores(response);
    } catch (err) {
      console.error('Error fetching supervisors:', err);
      Modal.error({
        title: 'Error',
        content: 'Error al cargar los supervisores',
      });
    }
  };

  // Update handleSearch to maintain the same filter
  const handleSearch = async value => {
    try {
      setSupervisorSearch(value);
      if (!value) {
        await getSupervisores();
        return;
      }
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          search: value,
          fields: [
            'id',
            'first_name',
            'last_name',
            'documento',
            'tope_de_prestamo',
            'prestamo_usado',
          ],
          filter: {
            role: {
              name: { _contains: 'supervisor_tropas' },
            },
            bodega: { id: { _eq: userBodega } },
          },
        })
      );
      setSupervisores(response);
    } catch (error) {
      console.error('Error searching supervisors:', error);
    }
  };

  useEffect(() => {
    getSupervisores();
  }, []);

  const onFinish = async ev => {
    const hasSerializedItems = arraytotalproductos.length > 0;
    const hasNonSerializedItems =
      productosagregadosver.filter(item => item.isNonSerialized).length > 0;
    if (!hasSerializedItems && !hasNonSerializedItems) {
      Modal.warning({
        title: 'No hay productos para prestar',
        content: 'Por favor agregue productos al préstamo e intente de nuevo',
      });
      return;
    }
    if (!supervisorSelect || !supervisorSelect.id) {
      Modal.error({
        title: 'Error',
        content: 'No se ha seleccionado un supervisor válido',
      });
      return;
    }

    Modal.confirm({
      title: '¿Está seguro de realizar el préstamo?',
      content: (
        <div>
          <p>
            Se va a realizar un préstamo para el supervisor:{' '}
            <b>
              {supervisorSelect.first_name ||
                supervisorSelect.nombre ||
                supervisorSelect.id}
            </b>
          </p>
          {hasSerializedItems && (
            <p>
              Seriales a prestar: <b>{arraytotalproductos.length}</b>
            </p>
          )}
          {hasNonSerializedItems && (
            <p>
              Productos no serializados a prestar:{' '}
              <b>
                {productosagregadosver
                  .filter(item => item.isNonSerialized)
                  .reduce((acc, item) => acc + (item.quantity || 0), 0)}
              </b>
            </p>
          )}
          <p>¿Desea continuar?</p>
        </div>
      ),
      okText: 'Sí, continuar',
      cancelText: 'Cancelar',
      onOk: async () => {
        setLoadings(true);
        const directus = await getDirectusClient();

        // Mostrar modal de progreso si hay muchos seriales
        let progressModal = null;
        if (hasSerializedItems && arraytotalproductos.length > 100) {
          progressModal = Modal.info({
            title: 'Procesando préstamo',
            content: `Iniciando procesamiento de ${arraytotalproductos.length} seriales...`,
            okButtonProps: { style: { display: 'none' } },
            closable: false,
          });
        }

        try {
          let arrguardar = [];
          let arrguardarp = [];
          let arrproducto = [];
          if (hasSerializedItems) {
            arraytotalproductos.map(p => {
              arrguardar.push({ id: p.id, user: '+', estado: 8 });
              arrguardarp.push({ id: p.id, prestamo: '+', estado: 8 });
            });
          }
          if (hasNonSerializedItems) {
            productosagregadosver.map(pro => {
              if (pro.isNonSerialized) {
                arrproducto.push({ id: pro.id });
              }
            });
          }
          const loanData = {
            vendedor: ev.supervisor,
            tipo: 'prestamo',
            estado: 'solicitud_prestamo',
            bodega: userBodega,
          };

          // NO agregar seriales aquí, los agregaremos después en lotes
          const loanResponse = await directus.request(
            createItem('prestamos', loanData)
          );

          if (loanResponse.id) {
            // NO procesar seriales en la BD, solo crear el préstamo base
            if (hasSerializedItems) {
              console.log(
                'Préstamo creado sin procesar seriales en BD. Cantidad de seriales:',
                arraytotalproductos.length
              );
            }

            // Cerrar modal de progreso si existe
            if (progressModal) {
              progressModal.destroy();
            }

            // Crear objeto con arrays de serializados y no serializados
            const prestamoObject = {
              id: loanResponse.id,
              user_created: user,
              vendedor: ev.supervisor,
              vendedor_nombre: supervisorSelect.first_name,
              fecha_creacion: new Date().toISOString(),
              estado: 'solicitud_prestamo',
              total_prestado: total,
              serializados: {
                cantidad: arraytotalproductos.length,
                items: arraytotalproductos.map(item => ({
                  id: item.id,
                })),
              },
              no_serializados: {
                cantidad: productosagregadosver.filter(
                  item => item.isNonSerialized
                ).length,
                items: productosagregadosver
                  .filter(item => item.isNonSerialized)
                  .map(item => ({
                    id: item.producto.id, // ID del producto
                    producto: item.producto,
                    cantidad: item.quantity,
                    precio: item.precio,
                    impuesto: item.impuesto,
                    total_parcial:
                      item.quantity * item.precio +
                      (item.quantity * item.precio * item.impuesto) / 100,
                  })),
              },
            };

            // Función para enviar el objeto a la API externa
            const enviarPrestamoAAPI = async prestamoData => {
              try {
                console.log('Enviando préstamo a API externa:', prestamoData);

                const response = await fetch(
                  Constants.URL_COMPLEMENTO + '/api/prestamos/crear',
                  {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(prestamoData),
                  }
                );

                if (response.ok) {
                  const result = await response.json();
                  console.log('Respuesta exitosa de la API:', result);
                  return { success: true, data: result };
                } else {
                  const errorData = await response.text();
                  console.error(
                    'Error en la respuesta de la API:',
                    response.status,
                    errorData
                  );
                  return {
                    success: false,
                    error: `HTTP ${response.status}: ${errorData}`,
                  };
                }
              } catch (error) {
                console.error('Error enviando préstamo a API externa:', error);
                return { success: false, error: error.message };
              }
            };

            // Enviar el objeto a la API externa
            const apiResult = await enviarPrestamoAAPI(prestamoObject);

            if (apiResult.success) {
              console.log('Préstamo enviado exitosamente a la API externa');
              console.log('Respuesta de la API:', apiResult.data);

              // Usar el historialId de la respuesta para crear detalle_historial_ns
              if (apiResult.data.historialId && hasNonSerializedItems) {
                console.log(
                  'Creando detalle_historial_ns con historialId:',
                  apiResult.data.historialId
                );

                for (const item of productosagregadosver.filter(
                  item => item.isNonSerialized
                )) {
                  const inventarioNoSerial = await directus.request(
                    readItems('inventario_no_serial', {
                      fields: ['*'],
                      filter: { producto: { id: { _eq: item.id } } },
                    })
                  );

                  if (inventarioNoSerial && inventarioNoSerial.length > 0) {
                    const inventarioNsId = inventarioNoSerial[0].id;

                    const existingPrestamo = await directus.request(
                      readItems('inventario_ns_prestamo', {
                        fields: ['*'],
                        filter: {
                          inventario_ns: { _eq: inventarioNsId },
                          estado: { _eq: 'solicitud_prestamo' },
                          prestamos: {
                            prestamos_id: {
                              vendedor: { _eq: ev.supervisor },
                            },
                          },
                        },
                        limit: 1,
                      })
                    );

                    let inventarioNsPrestamoResponse;

                    if (existingPrestamo && existingPrestamo.length > 0) {
                      const existingItem = existingPrestamo[0];
                      inventarioNsPrestamoResponse = await directus.request(
                        updateItem('inventario_ns_prestamo', existingItem.id, {
                          cantidad:
                            Number(existingItem.cantidad) +
                            Number(item.quantity),
                          prestamos: {
                            create: [
                              {
                                inventario_ns_prestamo_id:
                                  existingItem.id.toString(),
                                prestamos_id: { id: loanResponse.id },
                              },
                            ],
                            update: [],
                            delete: [],
                          },
                        })
                      );
                    } else {
                      inventarioNsPrestamoResponse = await directus.request(
                        createItem('inventario_ns_prestamo', {
                          cantidad: item.quantity,
                          estado: 'solicitud_prestamo',
                          inventario_ns: inventarioNsId,
                          prestamos: {
                            create: [
                              {
                                inventario_ns_prestamo_id: '+',
                                prestamos_id: { id: loanResponse.id },
                              },
                            ],
                          },
                        })
                      );
                    }

                    // Usar el historialId de la API externa
                    await directus.request(
                      createItem('detalle_historial_ns', {
                        cantidad: item.quantity,
                        historial_seriales: {
                          create: [
                            {
                              detalle_historial_ns_id: '+',
                              historial_seriales_id: {
                                id: apiResult.data.historialId,
                              },
                            },
                          ],
                        },
                        prestamo_ns_p: inventarioNsPrestamoResponse.id,
                      })
                    );
                  }
                }
              }
            } else {
              console.error(
                'Error enviando préstamo a API externa:',
                apiResult.error
              );
              // No fallar el proceso principal si la API externa falla
              Modal.warning({
                title: 'Advertencia',
                content: `El préstamo se creó exitosamente, pero hubo un problema enviando los datos a la API externa: ${apiResult.error}`,
              });
            }

            Modal.success({
              title: 'Proceso exitoso',
              content: `Se realizó el préstamo correctamente${
                hasSerializedItems
                  ? ` con ${arraytotalproductos.length} seriales procesados`
                  : ''
              }${
                hasNonSerializedItems
                  ? ` y ${productosagregadosver
                      .filter(item => item.isNonSerialized)
                      .reduce(
                        (acc, item) => acc + (item.quantity || 0),
                        0
                      )} productos no serializados agregados`
                  : ''
              }`,
            });

            setModalseriales(false);
            setProductosagregados([]);
            setProductosagregadosver([]);
            arraytotalproductos.splice(0, arraytotalproductos.length);
            setSupervisorSelect({});
          }
          setLoadings(false);
        } catch (error) {
          // Cerrar modal de progreso si existe
          if (progressModal) {
            progressModal.destroy();
          }

          console.error('Error creating loan:', error);
          Modal.error({
            title: 'Error',
            content: 'Error al crear el préstamo',
          });
          setLoadings(false);
        }
      },
      onCancel: () => {
        // No hacer nada, el usuario canceló
      },
    });
  };

  const seleccionarSupervisor = ev => {
    console.log(supervisores.find(item => item.id === ev));
    setSupervisorSelect(supervisores.find(item => item.id === ev));
    // Resetear búsqueda y restaurar listado por defecto
    setSupervisorSearch('');
    getSupervisores();
  };

  const onChange = key => {
    console.log(key);
  };

  useEffect(() => {
    ejecutaconversion();
  }, [productosagregados]);

  const ejecutaconversion = () => {
    // Separar productos serializados y no serializados
    const serializedItems = productosagregados.filter(
      item => !item.isNonSerialized
    );
    const nonSerializedItems = productosagregados.filter(
      item => item.isNonSerialized
    );

    // Procesar serializados
    arraytotalproductos.length = 0;
    serializedItems.forEach(item => {
      arraytotalproductos.push({
        id: item.id,
        serial: item.serial,
        producto: item.producto,
        isNonSerialized: false,
      });
    });

    // Procesar no serializados
    const nonSerializedMap = {};
    nonSerializedItems.forEach(item => {
      const productId = item.producto?.id;
      if (!productId) return;
      if (!nonSerializedMap[productId]) {
        nonSerializedMap[productId] = {
          id: productId,
          producto: item.nombre,
          isNonSerialized: true,
          quantity: 0,
          precio: item.producto?.preciosinimp || 0,
          impuesto: item.producto?.grupo?.impuesto || 0,
          seriales: [],
          rawItems: [],
        };
      }
      nonSerializedMap[productId].quantity += Number(item.quantity) || 0;
      nonSerializedMap[productId].rawItems.push(item);
      nonSerializedMap[productId].precio = item.producto?.preciosinimp || 0;
      nonSerializedMap[productId].impuesto =
        item.producto?.grupo?.impuesto || 0;
    });

    // Combinar para la tabla
    const finalProductosMap = {};
    arraytotalproductos.forEach(item => {
      const productId = item.producto?.id;
      if (!productId) return;
      if (!finalProductosMap[productId]) {
        finalProductosMap[productId] = {
          id: productId,
          producto: item.producto?.nombre,
          isNonSerialized: false,
          seriales: [],
          quantity: 0,
          precio: item.producto?.preciosinimp || 0,
          impuesto: item.producto?.grupo?.impuesto || 0,
          rawItems: [],
        };
      }
      finalProductosMap[productId].seriales.push({
        serial: item.serial,
        id: item.id,
      });
      finalProductosMap[productId].rawItems.push(item);
      finalProductosMap[productId].quantity =
        finalProductosMap[productId].seriales.length;
    });
    Object.values(nonSerializedMap).forEach(item => {
      const productId = item.id;
      if (!finalProductosMap[productId]) {
        finalProductosMap[productId] = {
          ...item,
          seriales: [],
        };
      } else {
        finalProductosMap[productId].isNonSerialized = true;
        finalProductosMap[productId].quantity += item.quantity;
        finalProductosMap[productId].rawItems.push(...item.rawItems);
      }
    });
    const productosArray = Object.values(finalProductosMap);
    setProductosagregadosver(productosArray.length > 0 ? productosArray : []);
  };

  useEffect(() => {
    const calculateTotal = productosagregadosver.reduce((acc, producto) => {
      const cantidad = producto.quantity || 0;
      const precio = parseFloat(producto.precio) || 0;
      const impuesto = parseFloat(producto.impuesto) || 0;
      const preciot = cantidad * precio;
      const totalp = parseFloat(preciot + (preciot * impuesto) / 100).toFixed(
        2
      );
      return acc + parseFloat(totalp);
    }, 0);
    setTotal(calculateTotal);
  }, [productosagregadosver]);

  console.log('supervisores', supervisores);

  const processFile = async file => {
    try {
      console.log('=== INICIO PROCESAMIENTO DE ARCHIVO ===');
      console.log('Archivo recibido:', file.name, 'Tamaño:', file.size);

      const text = await file.text();
      console.log(
        'Contenido del archivo (primeras 5 líneas):',
        text.split('\n').slice(0, 5)
      );

      const serialNumbers = text
        .split('\n')
        .map(line => line.trim())
        .filter(line => line.length > 0);

      console.log('Seriales extraídos del archivo:', serialNumbers.length);
      console.log('Primeros 5 seriales:', serialNumbers.slice(0, 5));
      console.log('Últimos 5 seriales:', serialNumbers.slice(-5));

      // Log específico para seriales de 19 dígitos antes del truncamiento
      const seriales19Digitos = serialNumbers.filter(
        serial => serial.length === 19
      );
      console.log(' ANÁLISIS DE SERIALES DE 19 DÍGITOS:');
      console.log(
        '  - Total de seriales de 19 dígitos encontrados:',
        seriales19Digitos.length
      );
      if (seriales19Digitos.length > 0) {
        console.log(
          '  - Ejemplos de seriales de 19 dígitos:',
          seriales19Digitos.slice(0, 5)
        );
      }

      // Aplicar truncamiento como en LoanCreate
      const truncatedSerialNumbers = serialNumbers.map(serial =>
        truncateSerial(serial, omitir1)
      );

      console.log('Configuración omitir1:', omitir1);
      console.log(
        'Seriales después del truncamiento:',
        truncatedSerialNumbers.length
      );

      // Verificar si el truncamiento cambió algún serial
      const changedSerials = serialNumbers.filter(
        (original, index) => original !== truncatedSerialNumbers[index]
      );
      if (changedSerials.length > 0) {
        console.log(
          ' SERIALES MODIFICADOS POR TRUNCAMIENTO:',
          changedSerials.length
        );
        console.log('  - Seriales modificados:', changedSerials.slice(0, 10));

        // Mostrar el antes y después de cada serial modificado
        changedSerials.slice(0, 5).forEach((original, index) => {
          const truncado =
            truncatedSerialNumbers[serialNumbers.indexOf(original)];
          console.log(`    ${index + 1}. "${original}" → "${truncado}"`);
        });
      } else {
        console.log('✅ No se modificó ningún serial por truncamiento');
      }

      // Verificar si hay caracteres especiales o espacios
      const problematicSerials = serialNumbers.filter(
        serial => /[^a-zA-Z0-9]/.test(serial) || serial.includes(' ')
      );
      if (problematicSerials.length > 0) {
        console.warn(
          '⚠️ Seriales con caracteres especiales o espacios:',
          problematicSerials
        );
      }

      setLoading(true);
      const directus = await getDirectusClient();
      const batchSize = 50;
      const batchPromises = [];

      console.log('Configuración de búsqueda:');
      console.log('- Tamaño de lote:', batchSize);
      console.log(
        '- Total de lotes:',
        Math.ceil(truncatedSerialNumbers.length / batchSize)
      );

      for (let i = 0; i < truncatedSerialNumbers.length; i += batchSize) {
        const batch = truncatedSerialNumbers.slice(i, i + batchSize);
        console.log(
          `Lote ${Math.floor(i / batchSize) + 1}:`,
          batch.length,
          'seriales'
        );
        console.log('Ejemplo de seriales en este lote:', batch.slice(0, 3));

        batchPromises.push(
          directus.request(
            readItems('seriales', {
              fields: ['*', 'producto.*', 'producto.grupo.*', 'producto.id'],
              filter: {
                _and: [
                  {
                    serial: { _in: batch },
                  },
                  {
                    estado: { _eq: 1 },
                  },
                ],
              },
              limit: -1,
            })
          )
        );
      }

      console.log('Ejecutando consultas a la base de datos...');
      const batchResults = await Promise.all(batchPromises);
      console.log(
        'Resultados de lotes:',
        batchResults.map(
          (result, index) =>
            `Lote ${index + 1}: ${result.length} seriales encontrados`
        )
      );

      const allSerials = batchResults.flat();
      console.log('Total de seriales encontrados en BD:', allSerials.length);

      if (allSerials.length > 0) {
        console.log(
          'Ejemplo de seriales encontrados:',
          allSerials.slice(0, 3).map(s => ({
            id: s.id,
            serial: s.serial,
            estado: s.estado,
            producto: s.producto?.nombre || 'N/A',
          }))
        );
      }

      if (!allSerials || allSerials.length === 0) {
        console.error('❌ ERROR: No se encontraron seriales válidos');
        console.error('Seriales originales:', serialNumbers.slice(0, 10));
        console.error(
          'Seriales truncados:',
          truncatedSerialNumbers.slice(0, 10)
        );
        console.error('Configuración omitir1:', omitir1);
        console.error('Posibles causas:');
        console.error('1. Los seriales no existen en la base de datos');
        console.error('2. Los seriales tienen estado diferente a 1');
        console.error('3. Hay diferencias en el formato de los seriales');
        console.error(
          '4. El truncamiento está modificando los seriales incorrectamente'
        );

        Modal.error({
          title: 'Seriales no encontrados',
          content: 'No se encontraron seriales válidos en el archivo',
        });
        return;
      }

      const foundSerials = new Set(allSerials.map(s => s.serial));
      const invalidSerials = truncatedSerialNumbers.filter(
        serial => !foundSerials.has(serial)
      );

      console.log('Seriales válidos encontrados:', foundSerials.size);
      console.log('Seriales inválidos:', invalidSerials.length);

      if (invalidSerials.length > 0) {
        console.warn('⚠️ Seriales inválidos:', invalidSerials.slice(0, 10));
        console.warn(
          'Estos seriales no se encontraron en la BD o tienen estado diferente a 1'
        );

        const DownloadButton = () => (
          <Button
            onClick={() => {
              const blob = new Blob([invalidSerials.join('\n')], {
                type: 'text/plain',
              });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'seriales_invalidos.txt';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            }}
          >
            Descargar seriales inválidos
          </Button>
        );
        Modal.info({
          title: 'Seriales inválidos o no disponibles',
          content: (
            <div>
              <div style={{ marginBottom: 8 }}>
                <b>Cantidad de seriales inválidos:</b> {invalidSerials.length}
              </div>
              <div
                style={{
                  maxHeight: 200,
                  overflowY: 'auto',
                  background: '#f5f5f5',
                  border: '1px solid #ddd',
                  padding: 8,
                  fontFamily: 'monospace',
                  fontSize: 13,
                  marginBottom: 8,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {invalidSerials.join('\n')}
              </div>
              <DownloadButton />
            </div>
          ),
        });
      }

      const nuevosSeriales = allSerials.map(serial => ({
        ...serial,
        prestamo: '+',
      }));

      console.log(
        '✅ Seriales procesados exitosamente:',
        nuevosSeriales.length
      );
      console.log('=== FIN PROCESAMIENTO DE ARCHIVO ===');

      setProductosagregados(prev => [...prev, ...nuevosSeriales]);
      Modal.success({
        title: 'Seriales cargados',
        content: `Se cargaron ${allSerials.length} seriales correctamente`,
      });
    } catch (error) {
      console.error('❌ ERROR en processFile:', error);
      console.error('Stack trace:', error.stack);
      Modal.error({
        title: 'Error',
        content: 'Error al procesar el archivo de seriales',
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'producto',
    },
    {
      title: 'Cantidad',
      dataIndex: 'quantity',
      render: text => text || 0,
    },
    {
      title: 'Precio unitario',
      dataIndex: 'precio',
      render: precio =>
        `${formatPrice(precio.toLocaleString(), signoMoneda) || 0}`,
    },
    {
      title: 'Impuesto',
      dataIndex: 'impuesto',
      render: impuesto => `${impuesto || 0}%`,
    },
    {
      title: 'Total parcial',
      key: 'totalparcial',
      render: (_, record) => {
        const cantidad = record.quantity || 0;
        const precio = parseFloat(record.precio) || 0;
        const impuesto = parseFloat(record.impuesto) || 0;
        const subtotal = precio * cantidad;
        const valorImpuesto = subtotal * (impuesto / 100);
        const total = formatPrice(subtotal + valorImpuesto, signoMoneda);
        return total.toLocaleString();
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {!record.isNonSerialized && (
            <Button
              onClick={() => {
                setSerialeslist(record.seriales);
                setModalseriales(true);
              }}
              icon={<EyeOutlined />}
              type="primary"
            >
              Ver seriales
            </Button>
          )}
          <Button
            onClick={() => {
              Modal.confirm({
                title: '¿Quieres eliminar este producto?',
                content: `Se eliminarán ${record.seriales.length} seriales asociados`,
                onOk() {
                  if (record.isNonSerialized) {
                    const updatedProductos = productosagregados.filter(
                      item =>
                        !(
                          item.isNonSerialized &&
                          item.producto?.id === record.id
                        )
                    );
                    setProductosagregados(updatedProductos);
                  } else {
                    const updatedProductos = productosagregados.filter(
                      item =>
                        !record.seriales.some(serial => serial.id === item.id)
                    );
                    setProductosagregados(updatedProductos);
                  }
                  setProductosagregadosver(prev =>
                    prev.filter(item => item.id !== record.id)
                  );
                },
              });
            }}
            icon={<DeleteOutlined />}
            type="primary"
          >
            Quitar producto
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layouts>
      <Title level={4}>Crear prestamo tropas</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="supervisor"
          label="Supervisor"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Selecciona un supervisor"
            showSearch={true}
            filterOption={false}
            onSearch={handleSearch}
            onChange={seleccionarSupervisor}
            searchValue={supervisorSearch}
            style={{ width: '300px' }}
          >
            {supervisores.map(supervisor => (
              <Option key={supervisor.id} value={supervisor.id}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span>
                    {supervisor.first_name} {supervisor.last_name}
                  </span>
                  {supervisor.tope_de_prestamo > 0 && (
                    <span style={{ color: '#52c41a' }}>
                      Tope:{' '}
                      {formatPrice(supervisor.tope_de_prestamo, signoMoneda)}
                    </span>
                  )}
                </div>
              </Option>
            ))}
          </Select>
        </Form.Item>
        {supervisorSelect.id ? (
          <>
            <Space size={'large'}>
              Maximo de prestamo:{' '}
              {formatPrice(supervisorSelect.tope_de_prestamo, signoMoneda)}
              <span style={{ color: 'red' }}>
                {'      '}
                Prestamo usado:{' '}
                {formatPrice(supervisorSelect.prestamo_usado, signoMoneda)}
              </span>
              <span style={{ color: 'green' }}>
                Disponible:{' '}
                {formatPrice(
                  supervisorSelect.tope_de_prestamo -
                    supervisorSelect.prestamo_usado,
                  signoMoneda
                )}
              </span>
            </Space>
          </>
        ) : null}
        <Table columns={columns} dataSource={productosagregadosver}></Table>
        Total a prestar : {formatPrice(total, signoMoneda)}
        <span style={{ color: 'red' }}>
          {parseFloat(total) >
          parseFloat(
            supervisorSelect.tope_de_prestamo - supervisorSelect.prestamo_usado
          )
            ? 'Se excedió el limite de prestamo para el supervisor seleccionado'
            : null}
        </span>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            disabled={
              parseFloat(total) >
              parseFloat(
                supervisorSelect.tope_de_prestamo -
                  supervisorSelect.prestamo_usado
              )
                ? true
                : false
            }
            type="primary"
            htmlType="submit"
            loading={loadings}
          >
            Crear prestamo
          </Button>
        </Form.Item>
      </Form>

      <h4>Añadir productos al prestamo</h4>
      <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }}>
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        <Upload
          accept=".txt"
          beforeUpload={file => {
            processFile(file);
            return false;
          }}
          fileList={fileList}
          onChange={({ fileList }) => setFileList(fileList)}
        >
          <Button icon={<UploadOutlined />} loading={loading} type="primary">
            Cargar archivo de seriales
          </Button>
        </Upload>
      </Space>
      <Modal
        title="Seriales"
        onOk={() => {
          setSerialeslist([]);
          setModalseriales(false);
          deletecambio = false;
        }}
        onCancel={() => {
          setModalseriales(false);
          deletecambio = false;
        }}
        open={modalseriales}
      >
        {serialeslist.map(serial => {
          return (
            <Space size={'small'}>
              {' '}
              <span>{serial.serial}</span>
              <Button
                onClick={() => {
                  console.log('eliminar serial ' + serial.serial);
                  console.log(productosagregados);

                  Modal.confirm({
                    title: 'Quieres eliminar serial ' + serial.serial,
                    onOk() {
                      let nuevosseriales = productosagregados.filter(
                        item => item.serial !== serial.serial
                      );

                      let arran = arraytotalproductos.filter(
                        item => item.serial !== serial.serial
                      );

                      arraytotalproductos.splice(0, arraytotalproductos.length);

                      arran.map(a => {
                        arraytotalproductos.push(a);
                      });

                      let lisserrialnew = serialeslist.filter(
                        item => item.serial !== serial.serial
                      );

                      setSerialeslist(lisserrialnew);

                      console.log(productosagregados.length);

                      setProductosagregados(nuevosseriales);
                      deletecambio = true;
                    },
                    onCancel() {
                      console.log('cancelar');
                    },
                  });
                }}
              >
                Eliminar
              </Button>
            </Space>
          );
        })}
      </Modal>
    </Layouts>
  );
}

export default TroopLoansCreate;
